var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "soc-smart-guide-panel" },
    [
      !_vm.sessionActive
        ? _c(
            "div",
            { staticClass: "guide-start" },
            [
              _c("p", { staticClass: "guide-lead" }, [
                _vm._v(_vm._s(_vm.$t("route.socSmartGuideLead")))
              ]),
              _vm._v(" "),
              _vm.netStatsLine
                ? _c("p", { staticClass: "guide-honesty muted" }, [
                    _vm._v(_vm._s(_vm.netStatsLine))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "guide-honesty muted" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.guideHonestyZh || _vm.$t("route.socSmartGuideLead")
                      ) +
                      "\n      "
                  ),
                  _vm.guideClass
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "6px" },
                          attrs: { size: "mini", type: "info", effect: "plain" }
                        },
                        [_vm._v(_vm._s(_vm.guideClass))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "guide-intent-row" },
                [
                  _c("el-input", {
                    attrs: {
                      size: "mini",
                      placeholder: _vm.$t(
                        "route.socSmartGuideIntentPlaceholder"
                      )
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.resolveIntent.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.intentText,
                      callback: function($$v) {
                        _vm.intentText = $$v
                      },
                      expression: "intentText"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        loading: _vm.loading
                      },
                      on: { click: _vm.resolveIntent }
                    },
                    [_vm._v(_vm._s(_vm.$t("route.socSmartGuideStart")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.clarifyQuestions.length
                ? _c(
                    "div",
                    { staticClass: "guide-clarify" },
                    _vm._l(_vm.clarifyQuestions, function(q) {
                      return _c(
                        "div",
                        { key: q.id, staticClass: "guide-clarify-q" },
                        [
                          _c("p", [_vm._v(_vm._s(q.promptZh))]),
                          _vm._v(" "),
                          _vm._l(q.options || [], function(opt) {
                            return _c(
                              "el-button",
                              {
                                key: q.id + "-" + opt.value,
                                attrs: { size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.answerClarify(q.id, opt.value)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(opt.labelZh || opt.value))]
                            )
                          })
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyStoreNeeded
                ? _c(
                    "div",
                    { staticClass: "guide-store-row" },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          placeholder: _vm.$t("route.socSmartGuideProxyStore")
                        },
                        model: {
                          value: _vm.proxyStoreId,
                          callback: function($$v) {
                            _vm.proxyStoreId = $$v
                          },
                          expression: "proxyStoreId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.noticeList.length
                ? _c(
                    "div",
                    { staticClass: "guide-unfinished" },
                    [
                      _c("p", { staticClass: "guide-unfinished-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("route.socSmartGuideNotices")) +
                            "（" +
                            _vm._s(_vm.noticeList.length) +
                            "）"
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.noticeList, function(n) {
                        return _c(
                          "div",
                          {
                            key: "nt-" + n.id,
                            staticClass: "guide-unfinished-row"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "guide-unfinished-meta" },
                              [
                                _c("strong", [_vm._v(_vm._s(n.titleZh))]),
                                _vm._v(" "),
                                _c("span", { staticClass: "muted" }, [
                                  _vm._v(
                                    " · " + _vm._s(_vm.noticeKindLabel(n.kind))
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "guide-unfinished-actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "mini",
                                      loading: _vm.loading
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.ackNotice(n.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("route.socSmartGuideAck"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.unfinishedList.length
                ? _c(
                    "div",
                    { staticClass: "guide-unfinished" },
                    [
                      _c("p", { staticClass: "guide-unfinished-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("route.socSmartGuideMyProcesses")) +
                            "（" +
                            _vm._s(_vm.unfinishedList.length) +
                            "）"
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.unfinishedList, function(u) {
                        return _c(
                          "div",
                          {
                            key:
                              "uf-" +
                              (u.refType || "g") +
                              "-" +
                              (u.refId || u.sessionId),
                            staticClass: "guide-unfinished-row"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "guide-unfinished-meta" },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      u.titleZh || u.playbookId || u.processId
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "muted" }, [
                                  _vm._v(
                                    " · " +
                                      _vm._s(_vm.processStatusLabel(u)) +
                                      " · " +
                                      _vm._s(
                                        u.currentStepTitleZh ||
                                          "步骤 " +
                                            ((u.currentStepIndex || 0) + 1)
                                      )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "guide-unfinished-actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      loading: _vm.loading
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openInboxItem(u)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.inboxActionLabel(u)))]
                                ),
                                _vm._v(" "),
                                u.sessionId
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          loading: _vm.loading
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.startGuide(
                                              u.playbookId,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("重新开始")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                u.sessionId
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          size: "mini",
                                          loading: _vm.loading
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.discardUnfinished(
                                              u.sessionId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("route.socSmartGuideDelete")
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-collapse",
                { staticClass: "guide-catalog" },
                [
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: _vm.$t("route.socSmartGuideCatalog"),
                        name: "catalog"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "guide-role-row" },
                        [
                          _c("span", { staticClass: "guide-role-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("route.socSmartGuideRolePreview"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "mini" },
                              on: { change: _vm.loadPlaybooks },
                              model: {
                                value: _vm.previewRole,
                                callback: function($$v) {
                                  _vm.previewRole = $$v
                                },
                                expression: "previewRole"
                              }
                            },
                            [
                              _c("el-radio-button", { attrs: { label: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("route.socSmartGuideRoleCurrent")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "store_manager" } },
                                [_vm._v("店长")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "store_clerk" } },
                                [_vm._v("店员")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "brand_ops" } },
                                [_vm._v("品牌")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "platform_admin" } },
                                [_vm._v("超管")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "guide-start-actions" },
                        [
                          _vm._l(_vm.activePlaybooks, function(pb) {
                            return _c(
                              "el-button",
                              {
                                key: pb.playbookId,
                                attrs: {
                                  type:
                                    pb.accessLevel === "primary"
                                      ? "primary"
                                      : "default",
                                  size: "small",
                                  loading: _vm.loading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.startGuide(pb.playbookId)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.accessMark(pb.accessLevel)) +
                                    _vm._s(pb.titleZh || pb.playbookId) +
                                    "\n          "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          !_vm.activePlaybooks.length
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    loading: _vm.loading
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.startGuide(
                                        "store_manager_dispenser_r1"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            开始：店长 · 饮料机\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _c("div", { staticClass: "guide-active" }, [
            _c(
              "div",
              { staticClass: "guide-head" },
              [
                _c("strong", [_vm._v(_vm._s(_vm.titleZh))]),
                _vm._v(" "),
                _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                  _vm._v(_vm._s(_vm.$t("route.socAssistantTabGuide")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.processEntryZh || _vm.processExitZh
              ? _c("p", { staticClass: "muted" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("route.socSmartGuideEntry")) +
                      "：" +
                      _vm._s(_vm.processEntryZh) +
                      "\n      "
                  ),
                  _vm.processExitZh
                    ? _c("span", [
                        _vm._v(
                          " · " +
                            _vm._s(_vm.$t("route.socSmartGuideExit")) +
                            "：" +
                            _vm._s(_vm.processExitZh)
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.processDemandZh || _vm.processResultZh
              ? _c("p", { staticClass: "muted" }, [
                  _vm.processDemandZh
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("route.socSmartGuideDemand")) +
                            "：" +
                            _vm._s(_vm.processDemandZh)
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.processResultZh
                    ? _c("span", [
                        _vm._v(
                          " · " +
                            _vm._s(_vm.$t("route.socSmartGuideResult")) +
                            "：" +
                            _vm._s(_vm.processResultZh)
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.needSlots
              ? _c(
                  "div",
                  { staticClass: "guide-clarify" },
                  [
                    _c("p", { staticClass: "guide-instruction" }, [
                      _vm._v(_vm._s(_vm.$t("route.socSmartGuideSlotsHint")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.missingSlots, function(q) {
                      return _c(
                        "div",
                        {
                          key: "slot-" + q.slotId,
                          staticClass: "guide-clarify-q"
                        },
                        [
                          _c("p", [_vm._v(_vm._s(q.promptZh))]),
                          _vm._v(" "),
                          _vm._l(q.options || [], function(opt) {
                            return _c(
                              "el-button",
                              {
                                key: q.slotId + "-" + opt.value,
                                attrs: { size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.answerSlot(q.slotId, opt.value)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(opt.labelZh || opt.value))]
                            )
                          }),
                          _vm._v(" "),
                          !(q.options && q.options.length)
                            ? _c(
                                "div",
                                { staticClass: "guide-intent-row" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "mini",
                                      placeholder: q.promptZh
                                    },
                                    model: {
                                      value: _vm.slotDraft[q.slotId],
                                      callback: function($$v) {
                                        _vm.$set(_vm.slotDraft, q.slotId, $$v)
                                      },
                                      expression: "slotDraft[q.slotId]"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        loading: _vm.loading
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.answerSlot(
                                            q.slotId,
                                            _vm.slotDraft[q.slotId]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "route.socSmartGuideSlotSubmit"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "muted" }, [
                      _vm._v(_vm._s(_vm.formFallbackZh))
                    ])
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ol",
              { staticClass: "guide-steps" },
              _vm._l(_vm.steps, function(s) {
                return _c(
                  "li",
                  {
                    key: s.stepId,
                    class: {
                      current: s.status === "CURRENT",
                      done: s.status === "DONE",
                      clickable: true
                    },
                    on: {
                      click: function($event) {
                        return _vm.goStepPage(s)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "step-mark" }, [
                      _vm._v(_vm._s(_vm.stepMark(s)))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(s.titleZh))])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.currentStep
              ? _c("div", { staticClass: "guide-current" }, [
                  _c("p", { staticClass: "guide-instruction" }, [
                    _vm._v(_vm._s(_vm.currentStep.instructionZh))
                  ]),
                  _vm._v(" "),
                  _vm.boundMachineCode &&
                  (_vm.currentStep.stepId === "verify_one_produce" ||
                    _vm.currentStep.stepId === "clerk_verify_produce")
                    ? _c("p", { staticClass: "guide-sn" }, [
                        _vm._v(
                          "\n        验收 SN：" +
                            _vm._s(_vm.boundMachineCode) +
                            "（点「去操作此页」会自动带上）\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.verifyReasonZh
                    ? _c(
                        "p",
                        {
                          staticClass: "guide-verify",
                          class: {
                            ok: _vm.verifyPassed,
                            bad: !_vm.verifyPassed
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.verifyReasonZh) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "guide-actions" },
                    [
                      !_vm.needSlots
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.goCurrentPage }
                            },
                            [_vm._v("去操作此页")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentStep &&
                      _vm.currentStep.appAction === "sim_xt90_brew"
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "mini",
                                loading: _vm.loading
                              },
                              on: { click: _vm.assistSimBrew }
                            },
                            [_vm._v("模拟点饮验收")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", loading: _vm.loading },
                          on: { click: _vm.refresh }
                        },
                        [_vm._v("检查是否完成")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "text" },
                          on: { click: _vm.cancelGuide }
                        },
                        [_vm._v(_vm._s(_vm.$t("route.socSmartGuideDelete")))]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.completedBanner
              ? _c("p", { staticClass: "guide-done" }, [
                  _vm._v("已完成引导闭环，可关闭。")
                ])
              : _vm._e()
          ]),
      _vm._v(" "),
      _c("soc-work-order-togo-dialog", {
        attrs: { visible: _vm.togoVisible, payload: _vm.togoPayload },
        on: {
          close: function($event) {
            _vm.togoVisible = false
          },
          jump: _vm.onTogoJump,
          voice: _vm.onTogoVoice
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8d022de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8d022de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/SocSmartGuidePanel.vue
// module id = null
// module chunks = 